import { proxy } from 'valtio';

export const HeaderStore = proxy({
  headerLoaded: false,
});

export const setHeaderLoaded = (loaded: boolean) => {
  HeaderStore.headerLoaded = loaded;
};
